import { Experiment, ExperimentClient } from "@amplitude/experiment-js-client";

/**
 * Amplitude Experiment client singleton.
 *
 * This module is separate from App.tsx to avoid circular dependency issues
 * when useInstrumentation.ts needs to access the experiment client.
 *
 * The client is initialized once when the app loads (in production only).
 */

// Using an object wrapper to satisfy ESLint's no-mutable-exports rule
const experimentClientHolder: { client: ExperimentClient | null } = {
  client: null,
};

/**
 * Initialize the Amplitude Experiment client.
 * Should be called once during app initialization (in App.tsx).
 */
export function initializeExperimentClient(): void {
  if (
    process.env.REACT_APP_AMPLITUDE_DEPLOYMENT_KEY &&
    process.env.NODE_ENV === "production"
  ) {
    experimentClientHolder.client = Experiment.initializeWithAmplitudeAnalytics(
      process.env.REACT_APP_AMPLITUDE_DEPLOYMENT_KEY
    );
    experimentClientHolder.client.start();
  }
}

/**
 * Get the Amplitude Experiment client instance.
 * Returns null if not initialized (e.g., in development or tests).
 */
export function getExperimentClient(): ExperimentClient | null {
  return experimentClientHolder.client;
}
